import { Link, useLocation, useNavigate } from "react-router-dom";
import { Phone, MessageCircle, MapPin, Mail } from "lucide-react";
import { SITE, waLink } from "../../data/site";

export default function Footer() {
  const location = useLocation();
  const navigate = useNavigate();

  const scrollTo = (id) => {
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: id } });
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="no-print relative bg-brand-ink text-white mt-24 overflow-hidden">
      <div className="glow" style={{ background: "#0084FF", width: 380, height: 380, bottom: -160, right: -80, opacity: 0.35 }} />
      <div className="relative max-w-6xl mx-auto px-6 py-16 grid gap-10 md:grid-cols-3">
        <div>
          <div className="font-display font-extrabold text-2xl">
            Clean<span className="text-brand-light">MyCar</span>
          </div>
          <p className="mt-4 text-white/60 leading-relaxed max-w-xs">
            Premium car wash at your doorstep in {SITE.city}. Safe, scratch free, professional cleaning.
          </p>
          <p className="mt-3 text-brand-light font-medium text-sm">{SITE.tagline}</p>
          <div className="mt-5 flex items-center gap-2 text-white/70">
            <MapPin className="w-4 h-4 text-brand-light" />
            <span className="text-sm">{SITE.city}, Uttar Pradesh</span>
          </div>
        </div>

        <div>
          <h3 className="font-display font-bold text-sm uppercase tracking-widest text-white/50">Quick links</h3>
          <ul className="mt-4 space-y-2 text-white/80">
            <li><Link data-testid="footer-link-home" to="/" className="hover:text-brand-light">Home</Link></li>
            <li><Link data-testid="footer-link-pricing" to="/pricing" className="hover:text-brand-light">Pricing</Link></li>
            <li><button data-testid="footer-link-how" onClick={() => scrollTo("how")} className="hover:text-brand-light">How It Works</button></li>
            <li><button data-testid="footer-link-transparency" onClick={() => scrollTo("transparency")} className="hover:text-brand-light">Transparency</button></li>
            <li><a data-testid="footer-work-with-us" href={waLink("Hi CleanMyCar! I'm interested in working with you.")} target="_blank" rel="noopener noreferrer" className="hover:text-brand-light">Work With Us</a></li>
          </ul>
        </div>

        <div>
          <h3 className="font-display font-bold text-sm uppercase tracking-widest text-white/50">Get in touch</h3>
          <a data-testid="footer-call" href={`tel:${SITE.phoneDial}`} className="mt-4 flex items-center gap-3 text-white/80 hover:text-brand-light">
            <Phone className="w-4 h-4" /> {SITE.phoneDisplay}
          </a>
          <a data-testid="footer-whatsapp" href={waLink()} target="_blank" rel="noopener noreferrer" className="mt-3 flex items-center gap-3 text-white/80 hover:text-brand-light">
            <MessageCircle className="w-4 h-4" /> WhatsApp us
          </a>
          <a data-testid="footer-email" href={`mailto:${SITE.email}`} className="mt-3 flex items-center gap-3 text-white/80 hover:text-brand-light">
            <Mail className="w-4 h-4" /> {SITE.email}
          </a>
        </div>
      </div>
      <div className="relative border-t border-white/10">
        <div className="max-w-6xl mx-auto px-6 py-6 text-white/50 text-sm flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} Clean My Car. All rights reserved.</span>
          <span>{SITE.areas}</span>
        </div>
      </div>
    </footer>
  );
}
